import { render, staticRenderFns } from "./EditTextDialog.vue?vue&type=template&id=e5437c66"
import script from "./EditTextDialog.vue?vue&type=script&lang=js"
export * from "./EditTextDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports